// SF New Deal + HSA Combined Logo Component
export const SFNewDealLogo = ({ size = 'medium' }) => {
  const maxWidths = {
    small: 120,
    medium: 160,
    large: 200
  };

  return (
    <img
      src="/sfnd-hsa-combined-logo.png"
      alt="SF New Deal & HSA"
      style={{ maxWidth: maxWidths[size], height: 'auto' }}
    />
  );
};

// Restaurant Dashboard Logo (uses same combined logo)
export const RestaurantLogo = ({ size = 'medium' }) => {
  const maxWidths = {
    small: 120,
    medium: 160,
    large: 200
  };

  return (
    <img
      src="/sfnd-hsa-combined-logo.png"
      alt="SF New Deal & HSA"
      style={{ maxWidth: maxWidths[size], height: 'auto' }}
    />
  );
};
